<template>
    <footer class="footer">
      <div class="footer-links">
        <div class="left-links link">
          <LocaleSwitcher />
          <a v-html="trustedHtmlLabel"
              :href="`https://support.kidjo.tv/hc/${$i18n.locale}/requests/new`"
              class="hide-portrait set-text-style">
          </a>
        </div>
        
        <div class="center-links link portrait-display">
          <a v-html="trustedHtmlLabel"
              :href="`https://support.kidjo.tv/hc/${$i18n.locale}/requests/new`"
              class="set-text-style">
          </a>
        </div>
        <div class="center-links link">
          <ProductSwitcher />
          <a :href="ifInExcludedLang() ? websiteUrl + '/faq' : websiteUrl + `/${$i18n.locale}` + '/faq'" class="hide-portrait">{{ $t('navigation_links_help')}}</a>
          <a :href="ifInExcludedLang() ? websiteUrl + '/about-us' : websiteUrl + `/${$i18n.locale}` + '/about-us'" class="hide-portrait">{{ $t('navigation_links_about')}}</a>
        </div>
        <div class="center-links link portrait-display">
          <a :href="ifInExcludedLang() ? websiteUrl + '/faq' : websiteUrl + `/${$i18n.locale}` + '/faq'">{{ $t('navigation_links_help')}}</a>
          <a :href="ifInExcludedLang() ? websiteUrl + '/about-us' : websiteUrl + `/${$i18n.locale}` + '/about-us'">{{ $t('navigation_links_about')}}</a>
        </div>
        <div class="right-links link">
          <a :href="ifInExcludedLang() ? websiteUrl + '/legalnotices' : websiteUrl + `/${$i18n.locale}` + '/legalnotices'" >{{ $t('footer_sections_legal_links_legal_notice') }}</a>
          <a :href="ifInExcludedLang() ? websiteUrl + '/privacy' : websiteUrl + `/${$i18n.locale}` + '/privacy'">{{ $t('footer_sections_legal_links_privacy_policy')}}</a>
          <a :href="ifInExcludedLang() ? websiteUrl + '/cookies' : websiteUrl + `/${$i18n.locale}` + '/cookies'">{{ $t('footer_sections_legal_links_legal_gscs')}}</a>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  import ProductSwitcher from './ProductSwitcher.vue';
  import LocaleSwitcher from './LocaleSwitcher.vue';
  export default {
    data: function() {
      return {
        websiteUrl: process.env.VUE_APP_WEBSITE_URL,
        excludedLang: ['ar', 'it', 'pt', 'en']
      }
    },
    computed: {
        trustedHtmlLabel () {
            return this.$t('footer_questions')
        },
    },
		components: {
			"ProductSwitcher": ProductSwitcher,
      "LocaleSwitcher": LocaleSwitcher
		},
    methods: {
      ifInExcludedLang () {
          return this.excludedLang.includes(this.$i18n.locale);
      }
    }
  };
  </script>
  
  <style scoped>
  .footer {
    background: white;
    text-align: center;
    border-top: 2px solid #020076;

    &.dark-bg-footer {
      background-color: #020076;
      border-top: 2px solid white;

      .left-links,
      .center-links,
      .left-links,
      .right-links {
        align-items: center;
        justify-content: center;
        a {
          color: white;
        }
      }
    }	
  }
  .set-text-style {
    font-family: 'Nunito-Regular' !important;
  }
  .set-text-style b {
    font-family: 'Nunito-ExtraBold' !important;
  }
  .footer-links {
    display: flex;
    justify-content: space-between;
    padding-block: 10px;
    align-items: center;
    margin: 0 auto;
    @media (min-width: 1024px) {
      flex-wrap: wrap;
    }
    @media (orientation: portrait) {
      flex-direction: column;
      gap: 20px;
    }
  }
  
  .left-links,
  .right-links {
    display: flex;
    gap: 10px;
    align-items: anchor-center;
    line-height: 1;
    align-items: center;
    justify-content: center;
  }
  
  .center-links {
    display: flex;
    text-align: center;
    gap: 10px;
    align-items: anchor-center;
    line-height: 1;
    align-items: center;
    justify-content: center;
  }
  
  .footer a {
    color: #020076;
    font-size: 16px;
    font-family: "Nunito-ExtraBold";
		text-decoration: none;

    @media (max-width: 830px ) {
      font-size: 11px; 
    }
  }
  
  .footer a:hover {
    text-decoration: none;
  }
  .portrait-display {
    display: none;
  }
@media (orientation: portrait) {
    .center-links {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .locale-display {
        display: flex;
        flex-direction: row;
    }
    .hide-portrait {
        display: none;
    }
    .portrait-display {
        display: flex;
        flex-direction: row;
    }
}
  </style>
  